import { privateAPI } from '@api/core'
import { MediaService } from '@api/service/mediaService'
import { throwError } from '@api/utils/throwError'

export const mediaDataRemote = (): MediaService => ({
  getMediaList: async (query) => {
    try {
      const response = await privateAPI.get({
        url: `/media`,
        params: query,
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  createMedia: async (formData) => {
    try {
      const response = await privateAPI.post({
        url: `/media`,
        type: 'multipart',
        data: formData,
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
  deleteMedia: async (body) => {
    try {
      const response = await privateAPI.delete({
        url: `/media`,
        data: body,
      })
      return response.data
    } catch (error) {
      throwError(error)
    }
  },
})
